import { useState, useEffect } from 'react';
import api from '../utils/api';

export function useChildren() {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchChildren = async () => {
      try {
        setLoading(true);
        const response = await api.get('/parent/children');
        setChildren(response.data.children || []);
        setError(null);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch children');
        setChildren([]);
      } finally {
        setLoading(false);
      }
    };

    fetchChildren();
  }, []);

  return { children, loading, error };
}
